import { useMemo, useState } from 'react';
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  IconButton,
  Paper,
  Tab,
  Tabs,
  ThemeProvider,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';

import './styles/App.css';
import { buildTheme } from './theme';
import DealerCodeSearch from './components/DealerCodeSearch';
import AccountDataViewer from './components/AccountDataViewer';

const STORAGE_KEY = 'add-ui:color-mode';

function App() {
  const [tabIndex, setTabIndex] = useState(0);
  const [mode, setMode] = useState(() => {
    const saved = typeof window !== 'undefined' && localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
    return typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  });

  const theme = useMemo(() => buildTheme(mode), [mode]);

  const toggleMode = () => {
    setMode((prev) => {
      const next = prev === 'dark' ? 'light' : 'dark';
      localStorage.setItem(STORAGE_KEY, next);
      return next;
    });
  };

  const requestOptions = { method: 'GET', headers: new Headers() };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppBar position="static" color="default" elevation={0}>
        <Toolbar>
          <Typography variant="h1" component="h1" sx={{ flexGrow: 1, fontSize: '1.25rem' }}>
            Account Data Distributor
          </Typography>
          <Tooltip title={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}>
            <IconButton onClick={toggleMode} color="inherit" aria-label="Toggle color mode">
              {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Paper elevation={0} sx={{ borderRadius: 2 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
            <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)}>
              <Tab label="Account Data Viewer" />
              <Tab label="Dealer Code Search" />
            </Tabs>
          </Box>
          <Box sx={{ p: 3 }}>
            {tabIndex === 0 && <AccountDataViewer requestOptions={requestOptions} />}
            {tabIndex === 1 && <DealerCodeSearch requestOptions={requestOptions} />}
          </Box>
        </Paper>
      </Container>
    </ThemeProvider>
  );
}

export default App;
